import classNames from 'classnames';
import React, { ComponentProps, useCallback } from 'react';

import css from './style.module.scss';

interface Props extends ComponentProps<'button'> {
  disabled?: boolean;
  postable?: boolean;
  onClick?: (event: React.MouseEvent) => void;
  small?: boolean;
  variant?: Variant;
  // このpropsを足したくないが、互換性のために一旦...
  // そもそもコンポーネントの外側にpaddingやmarginを持たせるべきではない
  noPadding?: boolean;
}

const Variant = {
  Primary: 'Primary',
  Secondary: 'Secondary',
} as const;

type Variant = (typeof Variant)[keyof typeof Variant];

export const SubmitButton: React.FC<Props> = ({
  disabled,
  onClick,
  postable,
  children,
  small,
  variant = Variant.Primary,
  noPadding = false,
  ...attr
}) => {
  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      if (disabled) {
        event.preventDefault();
        return;
      }
      if (onClick) {
        onClick(event);
      }
    },
    [onClick, disabled],
  );

  const classes = classNames(css.SubmitButton, {
    [css.isSmall]: small,
    [css.btn_padding]: !noPadding,
  });

  const buttonClassNames = classNames(css.SubmitButton__Button, {
    [css.primary]: variant === Variant.Primary && !disabled,
    [css.primary_disabled]: variant === Variant.Primary && disabled,
    [css.secondary]: variant === Variant.Secondary && !disabled,
    [css.secondary_disabled]: variant === Variant.Secondary && disabled,
  });

  return (
    <div className={classes}>
      <button
        {...attr}
        type="button"
        className={buttonClassNames}
        disabled={!!disabled}
        onClick={handleClick}
      >
        {children}
        {postable !== undefined && !postable && (
          <span className={css.SubmitButton__Loading} />
        )}
      </button>
    </div>
  );
};
